<template>
  <div class="speaker">
    <ImgComponent
      :head_img="data.head_img"
      width="500"
      height="500"
      class="speaker-img"
    />
    <span class="speaker-title">{{ data.title }}</span>
    <span class="speaker-description">{{ data.description }}</span>
  </div>
</template>

<script>
export default {
  name: "SpeakerComponent",
  props: {
    data: Object,
  },
};
</script>

<style lang="stylus">
.speaker {
  display flex
  flex-direction column
  gap 10px
  width 200px
  max-width 200px
  text-align center
  +below(480px) {
    width: 170px
    max-width: 170px
  }

  &-img {
    height 200px
    width 100%
    border-radius: 50px;
    object-fit cover
    object-position center
    +below(480px) {
      height: 170px
      border-radius: 30px
    }
  }

  &-title {
    font-weight: 700;
    font-size: 1.125em
    line-height: 140%;
  }
}
</style>
